import { IApplicationState } from '../../types/redux';

export function isRenterFormEnabledReducer(
  state: IApplicationState['isRenterFormEnabled'] = false,
): IApplicationState['isRenterFormEnabled'] {
  return state;
}
